/**
 * Генерирует картинку-заглушку с заданными размерами,
 * которую можно вставить в тег img через атрибут src.
 */

import { isBrowser } from './isBrowser';

export function getBlankImage(width: number, height?: number) {
  height = height ?? width;

  const blankImage = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg"></svg>`;
  const blankImageEncode = `%3Csvg width='${width}' height='${height}' xmlns='http://www.w3.org/2000/svg'%3E%3C/svg%3E`;

  return isBrowser
    ? `data:image/svg+xml;base64,${window.btoa(blankImage)}`
    : `data:image/svg+xml,${blankImageEncode}`;
}
